import { render } from "./Stacker.vue?vue&type=template&id=fda42c70"
import script from "./Stacker.vue?vue&type=script&lang=js"
export * from "./Stacker.vue?vue&type=script&lang=js"

import "./Stacker.vue?vue&type=style&index=0&id=fda42c70&lang=css"

import exportComponent from "/Users/imacgregor/dev/habitstacker/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__